/**
 * Alert component for error/info messages
 */

import type { ReactNode } from "react";

type AlertVariant = "error" | "info";

interface AlertProps {
  readonly variant?: AlertVariant;
  readonly children: ReactNode;
  readonly className?: string;
}

const variantClasses: Record<AlertVariant, string> = {
  error: "bg-status-error-bg text-status-error",
  info: "bg-status-info-bg text-text-primary",
};

export function Alert({
  variant = "error",
  children,
  className = "",
}: AlertProps) {
  return (
    <div
      role={variant === "error" ? "alert" : "status"}
      className={`rounded-md p-3 text-sm ${variantClasses[variant]} ${className}`}
    >
      {children}
    </div>
  );
}
